// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_pending.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AccessReviewPendingActionsService } from "./accessreview_pending";
import type { SearchSubmissionsByAdminResponse } from "./accessreview_pending";
import type { SearchSubmissionsByAdminRequest } from "./accessreview_pending";
import type { SearchSubmissionsResponse } from "./accessreview_pending";
import type { SearchSubmissionsRequest } from "./accessreview_pending";
import type { GetLatestSubmissionResponse } from "./accessreview_pending";
import type { GetLatestSubmissionRequest } from "./accessreview_pending";
import type { InitiateStepUpForSubmitResponse } from "./accessreview_pending";
import type { InitiateStepUpForSubmitRequest } from "./accessreview_pending";
import type { ListSubmissionsResponse } from "./accessreview_pending";
import type { ListSubmissionsRequest } from "./accessreview_pending";
import type { GetSubmissionStatusResponse } from "./accessreview_pending";
import type { GetSubmissionStatusRequest } from "./accessreview_pending";
import type { SubmitReviewResponse } from "./accessreview_pending";
import type { SubmitReviewRequest } from "./accessreview_pending";
import type { DiscardPendingBySearchResponse } from "./accessreview_pending";
import type { DiscardPendingBySearchRequest } from "./accessreview_pending";
import type { DiscardAllPendingResponse } from "./accessreview_pending";
import type { DiscardAllPendingRequest } from "./accessreview_pending";
import type { ValidatePendingActionsResponse } from "./accessreview_pending";
import type { ValidatePendingActionsRequest } from "./accessreview_pending";
import type { GetPendingActionsByTaskIDsResponse } from "./accessreview_pending";
import type { GetPendingActionsByTaskIDsRequest } from "./accessreview_pending";
import type { GetPendingSummaryResponse } from "./accessreview_pending";
import type { GetPendingSummaryRequest } from "./accessreview_pending";
import type { ListPendingActionsResponse } from "./accessreview_pending";
import type { ListPendingActionsRequest } from "./accessreview_pending";
import type { RemovePendingActionResponse } from "./accessreview_pending";
import type { RemovePendingActionRequest } from "./accessreview_pending";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { UpsertPendingActionResponse } from "./accessreview_pending";
import type { UpsertPendingActionRequest } from "./accessreview_pending";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewPendingActionsService
 */
export interface IAccessReviewPendingActionsServiceClient {
    /**
     * @generated from protobuf rpc: UpsertPendingAction
     */
    upsertPendingAction(input: UpsertPendingActionRequest, options?: RpcOptions): UnaryCall<UpsertPendingActionRequest, UpsertPendingActionResponse>;
    /**
     * @generated from protobuf rpc: RemovePendingAction
     */
    removePendingAction(input: RemovePendingActionRequest, options?: RpcOptions): UnaryCall<RemovePendingActionRequest, RemovePendingActionResponse>;
    /**
     * @generated from protobuf rpc: ListPendingActions
     */
    listPendingActions(input: ListPendingActionsRequest, options?: RpcOptions): UnaryCall<ListPendingActionsRequest, ListPendingActionsResponse>;
    /**
     * @generated from protobuf rpc: GetPendingSummary
     */
    getPendingSummary(input: GetPendingSummaryRequest, options?: RpcOptions): UnaryCall<GetPendingSummaryRequest, GetPendingSummaryResponse>;
    /**
     * @generated from protobuf rpc: GetPendingActionsByTaskIDs
     */
    getPendingActionsByTaskIDs(input: GetPendingActionsByTaskIDsRequest, options?: RpcOptions): UnaryCall<GetPendingActionsByTaskIDsRequest, GetPendingActionsByTaskIDsResponse>;
    /**
     * @generated from protobuf rpc: ValidatePendingActions
     */
    validatePendingActions(input: ValidatePendingActionsRequest, options?: RpcOptions): UnaryCall<ValidatePendingActionsRequest, ValidatePendingActionsResponse>;
    /**
     * @generated from protobuf rpc: DiscardAllPending
     */
    discardAllPending(input: DiscardAllPendingRequest, options?: RpcOptions): UnaryCall<DiscardAllPendingRequest, DiscardAllPendingResponse>;
    /**
     * @generated from protobuf rpc: DiscardPendingBySearch
     */
    discardPendingBySearch(input: DiscardPendingBySearchRequest, options?: RpcOptions): UnaryCall<DiscardPendingBySearchRequest, DiscardPendingBySearchResponse>;
    /**
     * @generated from protobuf rpc: SubmitReview
     */
    submitReview(input: SubmitReviewRequest, options?: RpcOptions): UnaryCall<SubmitReviewRequest, SubmitReviewResponse>;
    /**
     * @generated from protobuf rpc: GetSubmissionStatus
     */
    getSubmissionStatus(input: GetSubmissionStatusRequest, options?: RpcOptions): UnaryCall<GetSubmissionStatusRequest, GetSubmissionStatusResponse>;
    /**
     * @generated from protobuf rpc: ListSubmissions
     */
    listSubmissions(input: ListSubmissionsRequest, options?: RpcOptions): UnaryCall<ListSubmissionsRequest, ListSubmissionsResponse>;
    /**
     * @generated from protobuf rpc: InitiateStepUpForSubmit
     */
    initiateStepUpForSubmit(input: InitiateStepUpForSubmitRequest, options?: RpcOptions): UnaryCall<InitiateStepUpForSubmitRequest, InitiateStepUpForSubmitResponse>;
    /**
     * @generated from protobuf rpc: GetLatestSubmission
     */
    getLatestSubmission(input: GetLatestSubmissionRequest, options?: RpcOptions): UnaryCall<GetLatestSubmissionRequest, GetLatestSubmissionResponse>;
    /**
     * @generated from protobuf rpc: SearchSubmissions
     */
    searchSubmissions(input: SearchSubmissionsRequest, options?: RpcOptions): UnaryCall<SearchSubmissionsRequest, SearchSubmissionsResponse>;
    /**
     * @generated from protobuf rpc: SearchSubmissionsByAdmin
     */
    searchSubmissionsByAdmin(input: SearchSubmissionsByAdminRequest, options?: RpcOptions): UnaryCall<SearchSubmissionsByAdminRequest, SearchSubmissionsByAdminResponse>;
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewPendingActionsService
 */
export class AccessReviewPendingActionsServiceClient implements IAccessReviewPendingActionsServiceClient, ServiceInfo {
    typeName = AccessReviewPendingActionsService.typeName;
    methods = AccessReviewPendingActionsService.methods;
    options = AccessReviewPendingActionsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: UpsertPendingAction
     */
    upsertPendingAction(input: UpsertPendingActionRequest, options?: RpcOptions): UnaryCall<UpsertPendingActionRequest, UpsertPendingActionResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpsertPendingActionRequest, UpsertPendingActionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemovePendingAction
     */
    removePendingAction(input: RemovePendingActionRequest, options?: RpcOptions): UnaryCall<RemovePendingActionRequest, RemovePendingActionResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemovePendingActionRequest, RemovePendingActionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListPendingActions
     */
    listPendingActions(input: ListPendingActionsRequest, options?: RpcOptions): UnaryCall<ListPendingActionsRequest, ListPendingActionsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListPendingActionsRequest, ListPendingActionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPendingSummary
     */
    getPendingSummary(input: GetPendingSummaryRequest, options?: RpcOptions): UnaryCall<GetPendingSummaryRequest, GetPendingSummaryResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPendingSummaryRequest, GetPendingSummaryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPendingActionsByTaskIDs
     */
    getPendingActionsByTaskIDs(input: GetPendingActionsByTaskIDsRequest, options?: RpcOptions): UnaryCall<GetPendingActionsByTaskIDsRequest, GetPendingActionsByTaskIDsResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPendingActionsByTaskIDsRequest, GetPendingActionsByTaskIDsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ValidatePendingActions
     */
    validatePendingActions(input: ValidatePendingActionsRequest, options?: RpcOptions): UnaryCall<ValidatePendingActionsRequest, ValidatePendingActionsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<ValidatePendingActionsRequest, ValidatePendingActionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DiscardAllPending
     */
    discardAllPending(input: DiscardAllPendingRequest, options?: RpcOptions): UnaryCall<DiscardAllPendingRequest, DiscardAllPendingResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<DiscardAllPendingRequest, DiscardAllPendingResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DiscardPendingBySearch
     */
    discardPendingBySearch(input: DiscardPendingBySearchRequest, options?: RpcOptions): UnaryCall<DiscardPendingBySearchRequest, DiscardPendingBySearchResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<DiscardPendingBySearchRequest, DiscardPendingBySearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SubmitReview
     */
    submitReview(input: SubmitReviewRequest, options?: RpcOptions): UnaryCall<SubmitReviewRequest, SubmitReviewResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<SubmitReviewRequest, SubmitReviewResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSubmissionStatus
     */
    getSubmissionStatus(input: GetSubmissionStatusRequest, options?: RpcOptions): UnaryCall<GetSubmissionStatusRequest, GetSubmissionStatusResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSubmissionStatusRequest, GetSubmissionStatusResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListSubmissions
     */
    listSubmissions(input: ListSubmissionsRequest, options?: RpcOptions): UnaryCall<ListSubmissionsRequest, ListSubmissionsResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListSubmissionsRequest, ListSubmissionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: InitiateStepUpForSubmit
     */
    initiateStepUpForSubmit(input: InitiateStepUpForSubmitRequest, options?: RpcOptions): UnaryCall<InitiateStepUpForSubmitRequest, InitiateStepUpForSubmitResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<InitiateStepUpForSubmitRequest, InitiateStepUpForSubmitResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetLatestSubmission
     */
    getLatestSubmission(input: GetLatestSubmissionRequest, options?: RpcOptions): UnaryCall<GetLatestSubmissionRequest, GetLatestSubmissionResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLatestSubmissionRequest, GetLatestSubmissionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchSubmissions
     */
    searchSubmissions(input: SearchSubmissionsRequest, options?: RpcOptions): UnaryCall<SearchSubmissionsRequest, SearchSubmissionsResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchSubmissionsRequest, SearchSubmissionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchSubmissionsByAdmin
     */
    searchSubmissionsByAdmin(input: SearchSubmissionsByAdminRequest, options?: RpcOptions): UnaryCall<SearchSubmissionsByAdminRequest, SearchSubmissionsByAdminResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchSubmissionsByAdminRequest, SearchSubmissionsByAdminResponse>("unary", this._transport, method, opt, input);
    }
}
